import jwt from "jsonwebtoken";

export const createJWT = (input) => {
  return jwt.sign(input, process.env.REACT_APP_JWT_SECRET, {
    expiresIn: 60,
  });
};
